"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redrawOn = exports.toggle = void 0;
const mithril_1 = __importDefault(require("mithril"));
require("mithril/stream");
function toggle(t$, t) {
    t$(t$() == t ? undefined : t);
}
exports.toggle = toggle;
function redrawOn(...streams) {
    streams.forEach(t$ => {
        t$.map(() => mithril_1.default.redraw());
    });
}
exports.redrawOn = redrawOn;
